import styled from 'styled-components';

import TabsComponent from '@components/Tabs';
export const Wrapper = styled.div`
  display: flex;
  overflow: auto;
  .rc-tabs-nav-list {
    display: flex;
    margin: 0 0 16px;
  }
  .rc-tabs-tab {
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 25px;
    background-color: ${({ theme }) => theme.palette.white};
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme }) => theme.palette.eclipse};
  }
  .rc-tabs-tab-btn:focus {
    color: ${({ theme }) => theme.palette.eclipse};
  }
  .rc-tabs-tab-active {
    background-color: ${({ theme }) => theme.palette.tomato};
    border: none;
  }

  .rc-tabs-tab-active div {
    color: ${({ theme }) => theme.palette.white} !important;
  }

  .rc-tabs-ink-bar-animated {
    display: none !important;
  }

  .rc-tabs-nav::before {
    border-bottom: 0 !important;
  }

  .rc-tabs-tab + .rc-tabs-tab {
    margin: 0 0 0 20px;
  }
  .rc-tabs-nav-operations {
    display: none;
    & button,
    & svg {
      display: none;
    }
  }
`;
export const TabsDiv = styled.div`
  display: flex;
  margin-right: 10px;
`;
export const IconTab = styled.div`
  padding: 10px;
`;
export const Tab = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  height: 44px;
  border-radius: 75px;
  width: 44px;
`;
export const StyledTabs = styled(TabsComponent)``;
